import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { PasswordModalComponent } from 'app/pages/full-pages/admin/course/password-modal/password-modal.component';
import { Observable, of } from 'rxjs';
import { ApiService } from '../services/api.service';
import { catchError, map, switchMap } from 'rxjs/operators';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class PasswordGuard implements CanActivate {
  
  constructor(private dialog: MatDialog, private router: Router, private apiService: ApiService) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    const courseId = route.queryParams['id'];

    if (courseId) {
      return this.apiService.checkCoursePassword(courseId, '', '').pipe(
        map((res: any) => res?.data?.write_password),
        switchMap((writePassword: string | null) => {
          if (writePassword) {
            // Open the password dialog if write_password exists
            return this.openPasswordDialog(courseId);
          } else {
            // Allow access if no write_password is required
            return of(true);
          }
        }),
        catchError(() => {
          // Handle API errors by redirecting or denying access
          this.router.navigate(['/course/course-list']);
          return of(false);
        })
      );
    } else {
      // Allow access if no courseId is provided
      return of(true);
    }
  }

  private openPasswordDialog(courseId: string): Observable<boolean> {
    const dialogRef = this.dialog.open(PasswordModalComponent, {
      data: { courseId },
    });

    return dialogRef.afterClosed().pipe(
      map((result) => {
        if (result === 'correct_password') {
          return true;
        } else {
          // Redirect if the password is incorrect
          this.router.navigate(['/course/course-list']);
          return false;
        }
      })
    );
  }


}